import { Component, inject } from '@angular/core';
import { NgIf, NgFor, NgClass, AsyncPipe, isPlatformBrowser } from '@angular/common';
import { PLATFORM_ID } from '@angular/core';
import { ToastService } from 'src/app/services/toast.service';

@Component({
  selector: 'app-toast-container',
  standalone: true,
  imports: [NgIf, NgFor, NgClass, AsyncPipe], // ← importante para usar async en standalone
  template: `
    <ng-container *ngIf="isBrowser">
      <div class="toast-container">
        <div *ngFor="let msg of (toast.messages$ | async)" class="toast" [ngClass]="msg.type">
          {{ msg.text }}
        </div>
      </div>
    </ng-container>
  `,
  styleUrls: ['./toast-container.component.css']
})
export class ToastContainerComponent {
  isBrowser = isPlatformBrowser(inject(PLATFORM_ID));
  constructor(public toast: ToastService) {}
}